import { render } from "./LandDisplayPanel.vue?vue&type=template&id=b20f8068&scoped=true"
import script from "./LandDisplayPanel.vue?vue&type=script&lang=js"
export * from "./LandDisplayPanel.vue?vue&type=script&lang=js"

import "./LandDisplayPanel.vue?vue&type=style&index=0&id=b20f8068&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20f8068"]])

export default __exports__